import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/products';

export default function Products() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
